'use strict';

import angular from 'angular';

export function PrefixFilter() {
  'ngInject';

  let filter =
    (input, prefixString) => {
      if (!_.isUndefined(input) && input != null) {
        return (prefixString + input);
      }
      else {
        return '-';
      }
    };


  return filter;
}



// WEBPACK FOOTER //
// ./client/filter/prefix.filter.js